import React from "react";
import {
  ModalButtonContainer,
  NegativeModalButton,
  PositiveModalButton,
} from "../../components/Button";
import { Button } from "@mui/material";
import { CustomTextField } from "../../components/TextFields";
import { useModal } from "../../components/modal";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  useAddCategoryMutation,
  useUpdateCategoryMutation,
} from "../../app/services/categories.api";

const schema = yup.object().shape({
  title: yup.string().required("عنوان الزامی است."),
  desc: yup.string(),
});

export default function AddModal({
  defaultValue,
}: {
  defaultValue?: { _id: string; title: string; desc: string };
}) {
  const { setShow } = useModal();

  const [addCategory] = useAddCategoryMutation();
  const [updateCategory] = useUpdateCategoryMutation();
  const isEdit = !!defaultValue?._id;
  const {
    setValue,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValue ? defaultValue : {},
  });
  return (
    <React.Fragment>
      <CustomTextField
        label="نام"
        required
        placeholder="نام را وارد کنید."
        variant="outlined"
        defaultValue={getValues("title")}
        error={!!errors.title}
        helperText={errors.title?.message}
        onChange={(e) => {
          setValue("title", e.target.value);
        }}
      />

      <CustomTextField
        label="توضیحات"
        placeholder="توضیحات را وارد کنید."
        variant="outlined"
        multiline
        minRows={2}
        maxRows={4}
        defaultValue={getValues("desc")}
        error={!!errors.desc}
        helperText={errors.desc?.message}
        onChange={(e) => {
          setValue("desc", e.target.value);
        }}
      />
      <ModalButtonContainer>
        <Button
          style={NegativeModalButton}
          sx={{
            color: "divider",
            bgcolor: "primary.main",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            ":hover": {
              bgcolor: "divider",
              color: "primary.main",
            },
          }}
          onClick={() => setShow(false)}
        >
          انصراف
        </Button>
        <Button
          style={PositiveModalButton}
          sx={{
            ":hover": {
              bgcolor: "customColors.purple",
              color: "secondary.main",
            },
          }}
          onClick={handleSubmit((data) => {
            if (isEdit) {
              updateCategory({ categoryId: defaultValue._id, data })
                .unwrap()
                .then(() => {
                  setShow(false);
                })
                .catch((err) => {});
              return;
            }

            addCategory(data)
              .unwrap()
              .then(() => setShow(false))
              .catch((err) => {});
          })}
        >
          تایید
        </Button>
      </ModalButtonContainer>
    </React.Fragment>
  );
}
